import React, { useEffect } from "react";
import { ArrowLeft, X, Languages } from "lucide-react";
import EmailDetail from "./EmailDetail";
import { intestatario } from "../intestazione";

// Vista email a tutto schermo (copre l'intera finestra, web e PWA)
export default function FullscreenEmail({ email, ricevute, onClose, onRetryOutbox, onDeleteOutbox, onQuickReply, onTranslate, children }) {
  useEffect(() => {
    if (!email) return;
    const onKey = (e) => {
      if (e.key === "Escape") onClose();
    };
    window.addEventListener("keydown", onKey);
    document.body.classList.add("fs-open");
    return () => {
      window.removeEventListener("keydown", onKey);
      document.body.classList.remove("fs-open");
    };
  }, [email, onClose]);

  if (!email) return null;
  const isPec = email.categoria === "pec" || !!email.pec_tipo;
  return (
    <div className="fs-email" role="dialog" aria-modal="true" data-testid="fullscreen-email">
      <div className="fs-head">
        <button className="icon-btn icon-circle fs-btn con-tip" onClick={onClose} aria-label="Torna alla lista" data-tip="Torna alla lista" data-testid="fullscreen-back">
          <ArrowLeft size={24} strokeWidth={2.6} />
        </button>
        <div className="fs-title-box">
          <div className={`fs-title ${isPec ? "pec" : ""}`} title={email.oggetto || ""} data-testid="fullscreen-title">
            {email.oggetto || "(senza oggetto)"}
          </div>
          <div className="fs-sub">{intestatario(email)} · {email.data} {email.ora}</div>
        </div>
        {onTranslate && (
          <button className="icon-btn translate-btn fs-btn con-tip" onClick={onTranslate} aria-label="Traduci" data-tip="Traduci" data-testid="fullscreen-translate">
            <Languages size={26} strokeWidth={2.5} />
          </button>
        )}
        <button className="icon-btn fs-btn fs-close con-tip" onClick={onClose} aria-label="Chiudi" data-tip="Chiudi (Esc)" data-testid="fullscreen-close">
          <X size={26} strokeWidth={2.8} />
        </button>
      </div>
      <div className="fs-body">
        <EmailDetail
          email={email}
          ricevute={ricevute}
          onRetryOutbox={onRetryOutbox}
          onDeleteOutbox={onDeleteOutbox}
          onQuickReply={onQuickReply}
        />
      </div>
      {children && <div className="fs-toolbar">{children}</div>}
    </div>
  );
}
